import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuHistory, LuInfo} from 'react-icons/lu'

export function PatientDrawerTabsList() {
  const {t} = useTranslate('common')
  return (
    <Tabs.List>
      <Tabs.Trigger value="about">
        <LuInfo />
        {t('about')}
      </Tabs.Trigger>
      <Tabs.Trigger value="history">
        <LuHistory />
        {t('history')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
